/** IATA airline designator from flight number (e.g. "B6 1107" → "b6", "AF 11" → "af"). */
export function airlineDesignatorFromFlightNumber(flightNumber: string): string | null {
  const compact = (flightNumber || '').replace(/\s+/g, '').toLowerCase();
  const code = compact.slice(0, 2);
  return /^[a-z0-9]{2}$/.test(code) ? code : null;
}

export function airlineLogoUrl(flightNumber: string): string | null {
  const code = airlineDesignatorFromFlightNumber(flightNumber);
  if (!code) return null;
  return `https://airline-logo.skyluxtravel.com/result_no_bg/${code}.png`;
}

/** Logotype URL used on payment.skyluxtravel.com (SLT OAF). */
export function airlineLogotypePaymentUrl(flightNumber: string): string | null {
  const code = airlineDesignatorFromFlightNumber(flightNumber);
  if (!code) return null;
  return `https://payment-api.skyluxtravel.com/api/airlines/${code.toUpperCase()}/logotype`;
}
